<template>
  <div class="socket-error" v-if="$store.state.websocketConnectionError && !$store.state.socketDisconnect">
    <div class="horizontal layout center center-justified content-error-socket">
      <div class="flex">
        {{ $t('webSocketAlert') }}
      </div>

      <ui-button
        pill
        size="sm"
        variant="outline-dark"
        @click="reloadPage()"
      >
        <span class="mr-1">{{ $t('reloadTextLink') }}</span>
        <i class="fas fa-spinner" />
      </ui-button>
    </div>
  </div>
</template>
<script>
// UI
import UiButton from '@/components/UI/Button'

import Util from '@/util'

export default {
  components: {
    UiButton,
  },
  methods: {
    reloadPage() {
      Util.gaTrackEvent('Presentation Editor', 'No Websocket > Click Reload', 'Reaload page')
      window.location.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.socket-error {
  background-color: $danger-color;
  padding: 16px;
  color: #fff;

  .content-error-socket {
    max-width: 1024px;
    margin: 0 auto;
  }

  @media (max-width: 560px) {
    padding: 8px;
  }
}
</style>
